module.exports = __webpack_public_path__ + "static/shelf-dcf5ab1a0d97ba75bb0c00e5d62d92aa.png";